export default __webpack_public_path__ + "static/media/e-terview2.980c6851.png";